import React, { useEffect, useState } from 'react';
import vendorService from '../../../services/vendorService';

/**
 * Select an existing Vendor + one of its accounts. Calls onSelect with
 * { vendor, account } (account may be null if the vendor has none) whenever
 * the selection changes, so the parent form can prefill vendor/bank fields.
 */
const VendorPicker = ({ onSelect }) => {
  const [vendors, setVendors] = useState([]);
  const [vendorId, setVendorId] = useState('');
  const [accountId, setAccountId] = useState('');

  useEffect(() => {
    vendorService
      .listVendors()
      .then((res) => setVendors(res.data.data?.vendors || []))
      .catch(() => {});
  }, []);

  const selectedVendor = vendors.find((v) => String(v.id) === String(vendorId));

  const handleVendorChange = (id) => {
    setVendorId(id);
    setAccountId('');
    const vendor = vendors.find((v) => String(v.id) === String(id));
    onSelect?.({ vendor: vendor || null, account: null });
  };

  const handleAccountChange = (id) => {
    setAccountId(id);
    const account = (selectedVendor?.Accounts || []).find((a) => String(a.id) === String(id));
    onSelect?.({ vendor: selectedVendor || null, account: account || null });
  };

  return (
    <div className="grid grid-cols-2 gap-3">
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1">Vendor</label>
        <select
          value={vendorId}
          onChange={(e) => handleVendorChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
        >
          <option value="">Select vendor...</option>
          {vendors.map((v) => (
            <option key={v.id} value={v.id}>
              {v.company_name}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-700 mb-1">Bank Account</label>
        <select
          value={accountId}
          onChange={(e) => handleAccountChange(e.target.value)}
          disabled={!selectedVendor || !(selectedVendor.Accounts || []).length}
          className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm disabled:bg-gray-100"
        >
          <option value="">Select account...</option>
          {(selectedVendor?.Accounts || []).map((a) => (
            <option key={a.id} value={a.id}>
              {a.bank_name} - {a.account_number} {a.is_primary ? '(Primary)' : ''}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default VendorPicker;
